import { AntTab, AntTabs } from 'common/components/AntTabs'

import { IWisDetailsModalTabsProps } from './types'

export const WisDetailsModalTabs = ({
  state1,
  state2,
  currentState,
  onChange
}: IWisDetailsModalTabsProps) => {
  if (!state2) {
    return null
  }

  return (
    <div className='px-6'>
      <AntTabs value={currentState} onChange={onChange}>
        <AntTab label={state1?.name} value={state1} />
        <AntTab label={state2?.name} value={state2} />
      </AntTabs>
    </div>
  )
}

export default WisDetailsModalTabs
